import { createKvsApi } from "@org-avp/avp-avengers-kvs-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_GEOMETRY_SERVICE_BASE_URL,
  prepareHeaders,
};

export const kvsApi: ReturnType<typeof createKvsApi> = createKvsApi({
  baseQueryArgs,
});
